import Dashboard from '../components/Dashboard';
import GenericTab from '../components/GenericTab';

// Types of input fields and the layouts in GUI for them
// label-field is a 1 row layout in format : label | field
// label-over-field is a two row layout with the format --
//	label | add-button
//	list field that spans both columns
// In future we could do "full-wide" and label-over-textarea if needed.
export const TypesAndLayouts = {
  text: "label-field",
  textarea: "label-field",
  url: "label-field",
  boolean: "label-field",
  date: "label-field",
  select: "label-field",
  urlList: "label-over-field", 
  fileList: "label-over-field",
  linkList: "label-over-field"
} ;
  
//list of action buttons used within the application -- App Level
export const AppActionList = {
  create: { tooltip: "Create New Record" },
  refresh: { tooltip: "Refresh Table" },
  help: { tooltip: "Help with this Tab" },
  contribute: { tooltip: "Contribute" },
  preferences: { tooltip: "Preferences" },
  logout: { tooltip: "Logout" }
} ;

// Record Status options
export const RECORD_STATUS = {
  DRAFT: "Draft",
  ACTIVE: "Active",
  SNOOZED: "Snoozed"
}

// list of action buttons used within the application -- Record Level
export const RecordActionList = {
  viewRecord: { tooltip: "View Record" },
  updateRecord: { tooltip: "Update Record" },
  deleteRecord: { tooltip: "Delete Record" },
  snoozeRecord: { tooltip: "Snooze Record"},
  activateRecord: { tooltip: "Activate Record"}
} ;

const oneDay = 86400000 ; // miliseconds in a day (24*60*60*1000). Add n*oneDay to add n days to a date.
const today = () => new Date().toISOString().substring(0, 10) ;
const inSevenDays = () => new Date(Date.now() + 7*oneDay).toISOString().substring(0, 10) ;

  
// Details of each tab in the application
export const TabList = {

  dashboard: {
    label: "Dashboard",
    path: "/",
    uiComponent: Dashboard ,
    fields: [
      { name: "dataType", label: "Record Type", type: "text", required: true, showInTable: true },
      { name: "details", label: "Record Details", type: "text", required: true, showInTable: true },
      { name: "recordStatus", label: "Status", type: "text", required: true, showInTable: true },
      { name: "followupDate", label: "Followup Date", type: "text", required: true, showInTable: true }
    ] ,
    createRecordDefaults: {} 
  } ,


  jobApplications: {
    label: "Job Applications",
    path: "/job-applications",
    uiComponent: GenericTab ,
    fields: [
      { name: "companyName", label: "Company Name", type: "text", required: true, showInTable: true },
      { name: "jobID", label: "Job/Req ID", type: "text", required: false, showInTable: true },
      { name: "jobTitle", label: "Job Title", type: "text", required: true, showInTable: true },
//      { name: "contacts", label: "Contacts", type: "linkList", required: false, showInTable: true },
      { name: "appliedDate", label: "Applied Date", type: "date", required: true, showInTable: true },
      { name: "followupDate", label: "Followup Date", type: "date", required: true, showInTable: true },
      { name: "recordStatus", label: "Status", type: "select", required: true, showInTable: true, options:[RECORD_STATUS.DRAFT, RECORD_STATUS.ACTIVE, RECORD_STATUS.SNOOZED] },
      { name: "notes", label: "Notes", type: "textarea", required: false, showInTable: false },
      { name: "savedURLs", label: "Saved URLs", type: "urlList", required: false, showInTable: false },
      { name: "savedFiles", label: "Saved Files", type: "fileList", required: false, showInTable: false }
    ] ,
    createRecordDefaults: {
      appliedDate: today() ,
      followupDate: inSevenDays() ,
      recordStatus: RECORD_STATUS.ACTIVE ,
      savedURLs: [
        { displayText: "Job URL", url: "https://path.to/job.description" }
      ],
      savedFiles: [
        { displayText: "Resume", file: "" } ,
        { displayText: "Cover Letter", file: "" }
      ]
    } 
  },
  
  networking: {
    label: "Networking",
    path: "/networking",
    uiComponent: GenericTab ,
    fields: [
      { name: "contact", label: "Contact Name", type: "text", required: true, showInTable: true },
      { name: "company", label: "Company", type: "text", required: false, showInTable: true },
      { name: "jobTitle", label: "Job Title", type: "text", required: false, showInTable: true },
      { name: "association", label: "How I know them", type: "text", required: false, showInTable: true },
      { name: "lastContact", label: "Last Contact Date", type: "date", required: true, showInTable: true },
      { name: "followupDate", label: "Followup Date", type: "date", required: true, showInTable: true },
      { name: "phone", label: "Phone Number", type: "text", showInTable: false },
      { name: "email", label: "Email Address", type: "text", showInTable: false },
      { name: "recordStatus", label: "Status", type: "select", required: true, showInTable: true, options:[RECORD_STATUS.ACTIVE, RECORD_STATUS.SNOOZED] },
//      { name: "linkedinProfile", label: "LinkedIn Profile", type: "url", showInTable: false },
      { name: "notes", label: "Notes", type: "textarea", required: false, showInTable: false } ,
      { name: "savedURLs", label: "Saved URLs", type: "urlList", required: false, showInTable: false },
      { name: "savedFiles", label: "Saved Files", type: "fileList", required: false, showInTable: false }
    ] ,
    createRecordDefaults: {
      lastContact: today() ,
      followupDate: inSevenDays() ,
      recordStatus: RECORD_STATUS.ACTIVE ,
      savedURLs: [
        { displayText: "LinkedIn", url: "https://linkedIn.com/in/xxxx" }
      ]
    } 
  } ,

  targetCompanies: {
    label: "Target Companies",
    path: "/target-companies",
    uiComponent: GenericTab ,
    fields: [
      { name: "company", label: "Company", type: "text", required: true, showInTable: true },
//      { name: "careerWebsite", label: "Career Website", type: "text", required: false, showInTable: true },
      { name: "lastContact", label: "Last contact Date", type: "date", required: true, showInTable: true },
      { name: "followupDate", label: "Followup Date", type: "date", required: true, showInTable: true },
      { name: "recordStatus", label: "Status", type: "select", required: true, showInTable: true, options:[RECORD_STATUS.ACTIVE, RECORD_STATUS.SNOOZED] },
      { name: "notes", label: "Notes", type: "textarea", required: false, showInTable: false } ,
      { name: "savedURLs", label: "Saved URLs", type: "urlList", required: false, showInTable: false },
      { name: "savedFiles", label: "Saved Files", type: "fileList", required: false, showInTable: false }
    ] ,
    createRecordDefaults: {
      lastContact: today() ,
      followupDate: inSevenDays() ,
      recordStatus: RECORD_STATUS.ACTIVE ,
      savedURLs: [
        { displayText: "Career Website", url: "https://company.com/careers" },
        { displayText: "LinkedIn Profile" , url: "https://LinkedIn.com/companyProfile" }
      ]
    }  
  } ,
  
  events: {
    label: "Events",
    path: "/events",
    uiComponent: GenericTab ,
    fields: [
      { name: "eventName", label: "Event Name", type: "text", required: true, showInTable: true },
      { name: "eventType", label: "Event Type", type: "text", required: true, showInTable: true },
      { name: "eventDate", label: "Event Date", type: "date", required: true, showInTable: true },
      { name: "followupDate", label: "Remind On", type: "date", required: true, showInTable: true },
      { name: "repeats", label: "Regular event?", type: "boolean", required: false, showInTable: false },
      { name: "periodicity", label: "Periodicity", type: "text", required: false, showInTable: false },
      { name: "recordStatus", label: "Status", type: "select", required: true, showInTable: true, options:[RECORD_STATUS.ACTIVE, RECORD_STATUS.SNOOZED] },
      { name: "notes", label: "Notes", type: "textarea", required: false, showInTable: false } ,
      { name: "savedURLs", label: "Saved URLs", type: "urlList", required: false, showInTable: false },
      { name: "savedFiles", label: "Saved Files", type: "fileList", required: false, showInTable: false }
    ] ,
    createRecordDefaults: {
      eventDate: inSevenDays() ,
      followupDate: inSevenDays() ,
      recordStatus: RECORD_STATUS.ACTIVE ,
      savedURLs: [
        { displayText: "Event Website", url: "https://event.com/details" }
      ]
    }  
  } ,
  
  actionItems: {
    label: "Action Items",
    path: "/action-items",
    uiComponent: GenericTab ,
    fields: [
      { name: "actionItem", label: "Action Item", type: "text", required: true, showInTable: true },
      { name: "startDate", label: "Start Date", type: "date", required: true, showInTable: true },
      { name: "followupDate", label: "Followup Date", type: "date", required: true, showInTable: true },
      { name: "recordStatus", label: "Status", type: "select", required: true, showInTable: true, options:[RECORD_STATUS.ACTIVE, RECORD_STATUS.SNOOZED] },
      { name: "repeats", label: "Regular event?", type: "boolean", required: false, showInTable: false },
      { name: "periodicity", label: "Periodicity", type: "text", required: false, showInTable: false },
      { name: "notes", label: "Notes", type: "textarea", required: false, showInTable: false } ,
      { name: "savedURLs", label: "Saved URLs", type: "urlList", required: false, showInTable: false },
      { name: "savedFiles", label: "Saved Files", type: "fileList", required: false, showInTable: false }
    ] ,
    createRecordDefaults: {
      startDate: today() ,
      followupDate: inSevenDays() ,
      recordStatus: RECORD_STATUS.ACTIVE ,
    }    
  } ,
  
  learning: {
    label: "Continued Learning",
    path: "/learning",
    uiComponent: GenericTab ,
    fields: [
      { name: "learningItem", label: "Learning Effort", type: "text", required: true, showInTable: true },
      { name: "learningType", label: "Learning Type", type: "text", required: true, showInTable: true },
      { name: "startDate", label: "Started", type: "date", required: false, showInTable: true },
      { name: "followupDate", label: "Remind / Followup On", type: "date", required: false, showInTable: true },
      { name: "examDate", label: "Exam Date", type: "date", required: false, showInTable: true },
      { name: "recordStatus", label: "Status", type: "select", required: true, showInTable: true, options:[RECORD_STATUS.ACTIVE, RECORD_STATUS.SNOOZED] },
      { name: "notes", label: "Notes", type: "textarea", required: false, showInTable: false } ,
      { name: "savedURLs", label: "Saved URLs", type: "urlList", required: false, showInTable: false },
      { name: "savedFiles", label: "Saved Files", type: "fileList", required: false, showInTable: false }
    ] ,
    createRecordDefaults: {
      startDate: today() ,
      followupDate: inSevenDays() ,
      recordStatus: RECORD_STATUS.ACTIVE ,
      savedURLs: [
        { displayText: "Learning Website", url: "https://learning.edu/details" }
      ]
    }    
  }     
}

